/*
 * @Author: zhuyan 
 * @Date: 2021-11-24 17:07:42 
 * 公司资产 => 系统账号管理
 */

import React, { useState, useEffect, useRef } from 'react';
import api from '@/api';
import { Link } from 'react-router-dom';
import { Table, Button, Spin, Drawer, Popconfirm, message } from 'antd';
import CorpQuanQian from '@/components/CorpQuanQian';
import FiltersForm from '@/components/FiltersForm';
import { parseSearch } from '@/utils';
import Auth from '@/components/AuthMiddleware';
import Addsystem from './module/Addsystem'
import Import from '@/components/Import'

const System = (props) => {
  const { history, match, location } = props;
  const search = parseSearch(location.search);

  const initParams = {
    companyId: '',
    page: search.page || 1,
    limit: search.limit || 10,
  };

  const [states, setStates] = useState({
    dataSource: [], // 列表
    loading: true,
    total: 0, // 总条数
    filter: {
      project: [], // 项目
      groupList: [], // 事业群
      department: [] // 部门
    },
    // 筛选条件：列表接口参数
    params: initParams,
  });
  const { dataSource, filter, loading, total, params } = states;
  const ref = useRef()
  const ImportRef = useRef()

  const [authList, setAuthList] = useState([]); // 按钮权限
  const [groupVal, setGroupVal] = useState(undefined)
  const [editVisible, seteditVisible] = useState(false)
  const [addType, setAddType] = useState(0)
  const [editId, setEditId] = useState(null)
  const [formLoading, setformLoading] = useState(false)
  const [showImport, setShowImport] = useState(false)

  useEffect(() => {
    getList();
    const { page, limit, ...others } = params
  }, [params]);


  useEffect(() => {
    getPageAuth();
  }, []);

  // 获取列表
  const getList = () => {
    api
      .getAssetSystemAccountList(params)
      .then((res) => {
        setStates((current) => ({
          ...current,
          loading: false,
          dataSource: res.list,
          total: res.count,
        }));
      })
      .catch(() => {
        setStates((current) => ({
          ...current,
          loading: false,
        }));
      });
  };

  // 获取按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then((list) => {
      setAuthList(list);
    });
  };

  // 项目
  const getsysProjectChilds = () => {
    api.getsysProjectChilds({ pid: 0 }).then(data => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          project: data,
        },
      }));
    })
  }

  // 事业群
  const getSelectGroupList = () => {
    api.getSelectGroupList({ limit: global.paramsLimit }).then(data => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          groupList: data.list,
        },
      }));
    })
  }

  // 部门
  const getSelectDepartmentList = (val) => {
    api.getSelectDepartmentList({ limit: global.paramsLimit, groupId: val }).then(data => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          department: data.list,
        },
      }));
    })
  }

  // 点击选择所属公司
  const onChangeCorp = (data) => {
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...params,
        companyId: data.map((item) => item.id),
        page: 1,
      },
    }));
    history.replace(match.path);
  };

  // 分页点击
  const onChangeTable = (pagination, filters, sorter) => {
    const { current: page, pageSize: limit } = pagination;
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...params,
        page: page,
        limit: limit,
      },
    }));
    history.replace(match.path + '?page=' + page + '&limit=' + limit);
  };

  // 点击筛选
  const onSubmit = (values) => {
    initParams.page = 1;
    initParams.limit = 10;
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...initParams,
        companyId: params.companyId,
        ...values,
      },
    }));
    history.replace(match.path);
  }

  // 编辑
  const onEdit = (data) => {
    setformLoading(true)
    seteditVisible(true)
    setAddType(1)
    setEditId(data.id)
  }

  //申请
  const onAddSystem = () => {
    setEditId(null)
    setAddType(0)
    setformLoading(true)
    seteditVisible(true)
  }

  // 删除
  const onDelete = (id) => {
    api.getAssetSystemAccountDel({ id }).then(() => {
      message.success('删除成功')
      getList()
    })
  }

  // 导入确定
  const onConfirmImport = (fileList) => {
    if (fileList.length > 0) {
      if (fileList[0].status !== 'removed') {
        api.getAssetSystemAccountImport({
          uploadUrl: fileList[0].url
        }).then(res => {
          getList()
          message.success('导入成功')
          ImportRef.current.onLoading()
          setShowImport(false)
        }).catch(res => {
          // console.log('导入', res)
          ImportRef.current.onLoading()
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  const onShowImportDialog = () => {
    ImportRef.current.onRemoved()
    setShowImport(true)
  }

  const columns = [
    {
      title: '资产编号',
      dataIndex: 'number',
      valueType: 'Input',
      fixed: 'left',
      width: 120,
      fieldProps: {
        placeholder: '请输入资产编号',
      },
    },
    {
      title: '账号',
      dataIndex: 'accountName',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入账号',
      },
    },
    {
      title: '项目名',
      dataIndex: 'projectId',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.project.map((item) => ({
          label: item.name,
          value: item.id,
        })),
        onDropdownVisibleChange: (open) => {
          if (open) {
            getsysProjectChilds();
          }
        },
      },
      render: (text, record) => record.projectName,
    },
    { title: '公司主体', dataIndex: 'companyName' },
    {
      title: '使用人',
      dataIndex: 'userName',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入使用人',
      },
    },
    {
      title: '员工编号',
      dataIndex: 'userNumber',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入员工编号',
      },
    },
    {
      title: '所属事业群',
      dataIndex: 'userGroupId',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.groupList.map((item) => ({
          label: item.name,
          value: item.id,
        })),
        dropdownMatchSelectWidth: false,
        onDropdownVisibleChange: (open) => {
          if (open) {
            getSelectGroupList();
          }
        },
        onChange: (val) => {
          ref.current.setFieldsValue({
            'userGroupId': val,
            'userDepartmentId': undefined,
          })
          setGroupVal(val)
        }
      },
      render: (text, record) => record.userGroupName,
    },
    {
      title: '所属部门',
      dataIndex: 'userDepartmentId',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.department.map((item) => ({
          label: item.name + '（' + item.companyName + '）',
          value: item.id,
        })),
        dropdownMatchSelectWidth: false,
        onDropdownVisibleChange: (open) => {
          if (open) {
            getSelectDepartmentList(groupVal);
          }
        },
      },
      render: (text, record) => record.userDepartmentName,
    },
    { title: '密码', dataIndex: 'password' },
    {
      title: '开通时间',
      dataIndex: 'openingDate',
      valueType: 'RangePicker',
      search: {
        transform: (value) => {
          return {
            openingStartDate: value[0].format('YYYY-MM-DD'),
            openingEndDate: value[1].format('YYYY-MM-DD'),
          };
        },
      },
    },
    { title: '备注', dataIndex: 'remark' },
    {
      title: '操作',
      key: 'oprate',
      fixed: 'right',
      width: 80,
      align: "center",
      render: (text, record) => {
        return (
          <>
            <Button
              type='link'
              size='small'
              onClick={() => onEdit(record)}
            >
              编辑
            </Button>
            <Popconfirm title="请确认是否删除，删除后不可恢复。" cancelText="取消" okText="确认" onConfirm={() => onDelete(record.id)}>
              <Button
                type='link'
                size='small'
              >
                删除
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];

  return (
    <>
      <CorpQuanQian onChange={onChangeCorp} />
      <FiltersForm ref={ref} columns={columns} isNo={true} onSubmit={onSubmit} onReset={onSubmit} />
      <div className='line'></div>
      <div className='add-wrap'>
        <Auth auths={authList} code='add'>
          <Button
            type='primary'
            title='添加'
            onClick={onAddSystem}
            style={{ marginRight: 10 }}
          >
            添加
          </Button>
        </Auth>
        <Auth auths={authList} code='import'>
          <Button
            type='primary'
            title='导入'
            onClick={() => onShowImportDialog(true)}
            style={{ marginRight: 10 }}
          >
            导入
          </Button>
        </Auth>
      </div>
      {/* <Alert
        className='corp-count'
        message={`总计：${total}条数据`}
        type='info'
        showIcon
      /> */}
      <Table
        size='small'
        columns={columns}
        dataSource={dataSource}
        rowKey='id'
        loading={loading}
        className='askforleave-table'
        pagination={{
          pageSize: parseInt(params.limit),
          total: total,
          current: parseInt(params.page),
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        // scroll={{ x: 'max-content' }}
        scroll={{ x: 1600, y: 500 }}
      ></Table>
      <Drawer
        title={editId ? '系统账号信息编辑' : '资产添加'}
        width={600}
        onClose={() => seteditVisible(false)}
        visible={editVisible}
        destroyOnClose={true}
      >
        <Spin spinning={formLoading}>
          <Addsystem
            setformLoading={setformLoading}
            seteditVisible={seteditVisible}
            getList={getList}
            addType={addType}
            editId={editId}
          />
        </Spin>
      </Drawer>
      <Import
        onSearch={onConfirmImport}
        visibleFile={showImport}
        onCloseImport={() => setShowImport(false)}
        ImportTemplate="/api/File/DownTemplate?url=/templates/systemAccount.xlsx&name=导入系统账号模板"
        ImportRef={ImportRef}
      />
    </>
  );
};

export default System
